import { MessageBar, MessageBarBody, MessageBarTitle, MessageBarActions, Button } from '@fluentui/react-components';
import { useVersionCheck } from '../hooks/useVersionCheck';

export function UpdateBanner() {
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <MessageBar intent="info" layout="multiline">
      <MessageBarBody>
        <MessageBarTitle>New version available</MessageBarTitle>
        A newer version of the portal has been deployed. Reload to get the latest fixes.
      </MessageBarBody>
      <MessageBarActions>
        <Button appearance="primary" size="small" onClick={() => window.location.reload()}>
          Reload now
        </Button>
      </MessageBarActions>
    </MessageBar>
  );
}
